<template>
  <ion-page id="register-page">
    <ion-content>
      <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
           :style="styleOneFrame" :key="menuTrigger">

        <ion-item>
          <h5>{{ message }}</h5>
        </ion-item>
        
        <ion-item v-if="!showEmailPassword">
          <div>
            <p>{{ t("The version 9 has all the programs under the 'Hamburger - 3 bar' icon in the upper left.") }}</p>
            <p>{{ t("Note: The Video menu has moved to the righthand menu.") }}"</p>
          </div>
        </ion-item>

      <div v-if="showEmailPassword">

        <ion-item>
          <ion-input :label="emailString" label-placement="fixed" 
                    :placeholder="enterEmailString" :value="email"
                    @ionInput="emailInputChange">
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-input :label="passwordString" type="password" label-placement="fixed" 
                    :placeholder="enterPasswordString" :value="password"
                    @ionInput="passwordInputChange">
            <ion-input-password-toggle slot="end"></ion-input-password-toggle>
          </ion-input>
        </ion-item>

        <ion-item>
          <ion-input :label="passwordString" type="password" label-placement="fixed" 
                    :placeholder="enterPasswordString" :value="password2"
                    @ionInput="password2InputChange">
            <ion-input-password-toggle slot="end"></ion-input-password-toggle>
          </ion-input>
        </ion-item>

        <ion-item>
                <ion-button expand="block" size="large" @click="doRegister()" >{{ t("Register") }}</ion-button>
             
        </ion-item>
      </div>
      <div v-if="whichMenu == 'buttons'">
        <ion-item>
          <ion-button expand="full" size="large" @click="returnToButtonMenu()" >{{ t("Return to Big Button Menu") }}</ion-button>
        </ion-item>
      </div>
    </div>
    </ion-content>
  </ion-page>
</template>

<script setup>

import { IonGrid,IonRow,IonCol,IonButton,IonItem,IonInput,IonPage, IonContent , modalController, IonInputPasswordToggle } from '@ionic/vue';

import { ref, watch } from 'vue';
import ModalErrorMessage from '@/components/ModalErrorMessage.vue'
import { t } from '@/composables/translateText.js'

import { useGetData } from '@/composables/getData.js'
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { doStartupCheck } from '@/composables/startupCheck.js'
import { availableWidthHeight }  from '@/composables/screenSize'

const emit = defineEmits(['signin-status-change','next-item-click'])

const connectionStore = useConnectionStore()

const isDark = ref(connectionStore.getDarkmode != "light")
const menuTrigger = ref(0)

const whichMenu = localStorage.getItem("whichMenu")
const showBigButtons = ref(whichMenu == "buttons" || connectionStore.getShowBigButtons)

const windowSizeStore = useWindowSizeStore()
const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] })

const email = ref("")
const password = ref("")
const password2 = ref("")

const message = ref(t("Please Register below"))
const showEmailPassword = ref(true)

const emailString = ref(t("Email"))
const enterEmailString = ref(t("Enter email"))
const passwordString = ref(t("Password"))
const enterPasswordString = ref(t("Enter password"))


const styleOneFrame = ref({
   position : "absolute",
   "overflow-y" : "scroll",
   top : "0px",
   left : "100px",
   width: "100px",
   height : "100px"
 })

 updateWidthHeights()

watch(() => windowSizeStore.getWindowSize, () => {
    //console.log('*********** window size changes detected')
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    //console.log("*** logoff new window size",windowSizeRef.value)
    updateWidthHeights()
    menuTrigger.value++
  })

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
  if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
  menuTrigger.value++
  emit('signin-status-change',true)
}

function updateWidthHeights() {

  const availableSpace = availableWidthHeight()
  const oneframePositionTop = availableSpace.topIndent
  const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
  const oneframeHeight = availableSpace.height - oneframePositionTop + availableSpace.topIndent
  const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

  styleOneFrame.value.height = oneframeHeight + "px"
  styleOneFrame.value.width = oneframeWidth + "px"
  styleOneFrame.value.top = oneframePositionTop + "px"
  styleOneFrame.value.left = oneframePositionLeft + "px"

  //console.log("frame size",styleOneFrame.value)
}

function processJsonResponse (json) {
  //console.log(" in callback",json)
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }
  switch (json['stat']) {
    case 'g' :
      const cookie = json['cookie']
      connectionStore.setUserCookieDummy(cookie,"0")
      connectionStore.setEmailAddress(email.value)

      message.value = t("Welcome") + "!"
      showEmailPassword.value = false
      doStartupCheck(true,afterStartupCallbackRoutine)
      break
    default :
      message.value = t("Email is already in the system. Please Signin")
      break;
  }
}

function emailInputChange(ev) {
    //console.log("email ",ev)
    const value = ev.target.value;
    //console.log("email",value)
    email.value = value.trim()
  }


  function passwordInputChange(ev) {
    //console.log("password ",ev)
    const value = ev.target.value;
    //console.log("password",value)
    password.value = value.trim()
  }


  function password2InputChange(ev) {
    //console.log("password2 ",ev)
    const value = ev.target.value;
    //console.log("password2",value)
    password2.value = value.trim()
  }

function doRegister () {
  if (email.value == "") {
    message.value = t("Please enter your email address")
    return
  }
  if (password.value == "") {
    message.value = t("Please enter your password")
    return
  }
  if (password2.value != password.value) {
    message.value = t("Passwords don't match")
    return
  }
  message.value = t("registering") + "...."
  var formData = { e : email.value , p: password.value }
  useGetData("mobile_register.php", formData, processJsonResponse)
}

function returnToButtonMenu() {
  emit("next-item-click","big_button_menu",t("Big Button Menu"),"buttons")
}

</script>

<style scoped>

.item{
  margin:10px auto;
}

</style>